import { FontWeights } from '@uifabric/styling';
export var CheckStyles = function CheckStyles(props) {
  var theme = props.theme,
      checked = props.checked;
  var palette = theme.palette;
  return {
    circle: [!checked && {
      color: palette.neutralSecondary
    }],
    check: [!checked && {
      color: palette.neutralSecondary
    }]
  };
};
export var DetailsRowStyles = function DetailsRowStyles(props) {
  var theme = props.theme,
      isSelected = props.isSelected;
  var palette = theme.palette;
  var neutralPrimary = palette.neutralPrimary,
      neutralSecondary = palette.neutralSecondary,
      neutralLight = palette.neutralLight,
      neutralQuaternaryAlt = palette.neutralQuaternaryAlt;
  return {
    root: [{
      color: neutralSecondary
    }, isSelected && {
      color: neutralPrimary
    }, {
      selectors: {
        ':focus $check': {
          opacity: 1
        }
      }
    }, isSelected && [{
      background: neutralLight,
      selectors: {
        ':hover': {
          background: neutralQuaternaryAlt
        },
        ':focus': {
          background: neutralLight
        },
        ':focus:hover': {
          background: neutralQuaternaryAlt
        }
      }
    }]],
    isRowHeader: [{
      color: neutralPrimary
    }, isSelected && {
      fontWeight: FontWeights.semibold
    }]
  };
};